// extracted by mini-css-extract-plugin
export default {"delete-channel-popup__content":"DeleteChannelPopup_delete-channel-popup__content__HMXzW"};